/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import * as React from "react";
import { NavBar } from "../../common/NavBar";
import { MetadataTagZonesBreadcrumbs } from "./MetadataTagZonesBreadcrumbs";
import { createIgnoreZonesLinksArray } from "./EditMetadataTagZonesUtils/createIgnoreZonesLinksArray";
import { useNavigate } from "react-router-dom";
import { pointsCreator } from "./EditMetadataTagZonesUtils/pointsCreatorLarger";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import BackdropLoadingScreen from "../../common/BackdropLoadingScreen";
import { EditViewSyncButton } from "../../common/EditViewSyncButton";
import { SyncNeededBanner } from "../../common/SyncNeededBanner";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { Autocomplete, TextField, Tooltip } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { getAllCameras } from "../EditCamera/EditCameraUtils/getAllCameras";
import {
  getNumbersAfterEditCamera,
  getNumbersAfterSites,
} from "../EditCamera/EditCamera";
import { useEditIMetadataTagZonesStore } from "./editIMetadataTagZonesStore/editIMetadataTagZonesStore";
import { MetaDataTagZoneBuilder } from "./MetaDataTagZoneBuilder";
import { AddMetaDataIgnoreZoneDialog } from "./AddMetaDataIgnoreZoneDialog";
import { metadataTagZonesColorArray } from "./EditMetadataTagZonesUtils/metadataTagZonesColorArray";
import { transformNormalizedToPixelCoordinates } from "./EditMetadataTagZonesUtils/transformCoordinates";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteIcon from "@mui/icons-material/Delete";

export const EditIMetadataTagZones = ({
  navBarCollapsed,
  setNavBarCollapsed,
}: {
  navBarCollapsed: boolean;
  setNavBarCollapsed: Dispatcher<boolean>;
}) => {
  const {
    metadataTagZones,
    breadcrumbs,
    editorVisible,
    setEditorVisible,
    setSelectedMetadataTagZone,
    editsMade,
    pageLoading,
    largerMode,
    dimensions,
    getAllEditMetaDataTagZonesPageInfo,
    imageURLmdtz,
    setImageURLmdtz,
    setAddMetaDataIgnoreZoneDialogOpen,
    setShapeColor,
    shapeColorIndex,
    setShapeColorIndex,
    addMetaDataIgnoreZoneDialogOpen,
    setNewMetadataTagZone,
    setShapesArray,
    setMtzPolygonPoints,
    mdtzBuilder,
    setMdtzBuilder,
    selectedMetadataTagZone,
    metricLabels,
    setSelectedMetadataTagZoneIndex,
    editedTagZoneIndexes,
    setEditedTagZoneIndexes,
    selectedMetadataTagZoneIndex,
    setEditsMade,
    handlePostMetadataTagZones,
    setPageLoading,
    handleDeleteMetadataTagZone,
    cameraInfo,
  } = useEditIMetadataTagZonesStore();

  const handleImageLoad = () => {
    // Image loaded successfully
    // setDimensions(resizeImage(naturalWidth, naturalHeight));
  };

  const navigate = useNavigate();

  const siteId = Number(getNumbersAfterSites(location.href));

  const handleSitesBreadcrumbClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    localStorage.setItem("level0Click", "false");
    localStorage.setItem("navigatedFromSitesAboutPage", "false");
    navigate("/sites");
  };

  const handleSingularSiteBreadcrumbClick = () => {
    navigate(`/sites/aboutsite/${siteId}`);
  };

  const handleIgnoreZoneClick = (object: any) => {
    setSelectedMetadataTagZone(object);
    setShapeColor(object.line_color);

    // Transform normalized coordinates to pixel coordinates for editing
    const pixelCoordinates = transformNormalizedToPixelCoordinates(
      object.coordinates,
      dimensions.width,
      dimensions.height
    );

    setShapesArray(pixelCoordinates);
    setEditorVisible(true);
  };

  const [allCamerasData, setAllCamerasData] = React.useState<any[]>([]);

  const [cameraIndex, setCameraIndex] = React.useState(0);

  React.useEffect(() => {
    getAllEditMetaDataTagZonesPageInfo(navigate);
    getAllCameras(
      Number(getNumbersAfterSites(location.href)),
      Number(getNumbersAfterEditCamera(location.href)),
      setAllCamerasData,
      setCameraIndex
    );
    localStorage.setItem("siteId", getNumbersAfterSites(location.href));
    localStorage.setItem(
      "currentCameraId",
      getNumbersAfterEditCamera(location.href)
    );
  }, [getAllEditMetaDataTagZonesPageInfo, navigate]);

  // Add effect to handle camera changes
  React.useEffect(() => {
    const currentCameraId = getNumbersAfterEditCamera(location.href);
    if (currentCameraId) {
      getAllEditMetaDataTagZonesPageInfo(navigate);
    }
  }, [getAllEditMetaDataTagZonesPageInfo, navigate]);

  React.useEffect(() => {
    if (editorVisible) {
      setMdtzBuilder(<MetaDataTagZoneBuilder />);
    } else {
      setMdtzBuilder(<></>);
    }
  }, [editorVisible, setMdtzBuilder]);

  return (
    <div>
      <SyncNeededBanner navigate={navigate} />
      {addMetaDataIgnoreZoneDialogOpen && <AddMetaDataIgnoreZoneDialog />}
      <AddMetaDataIgnoreZoneDialog />
      <div className="bg-actuate-grey absolute w-full h-full overflow-scroll">
        <BackdropLoadingScreen openState={pageLoading} />
        {
          // !pageLoading &&
          allCamerasData[0] && (
            <div>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[15px] left-[150px] right-[1px] h-[59px] bg-white"
                    : "absolute top-[15px] left-[75px] right-[1px] h-[59px] bg-white"
                }
              >
                <MetadataTagZonesBreadcrumbs
                  linksArray={createIgnoreZonesLinksArray(breadcrumbs)}
                  handleSitesBreadcrumbClick={handleSitesBreadcrumbClick}
                  handleSingularSiteBreadcrumbClick={
                    handleSingularSiteBreadcrumbClick
                  }
                  styling="absolute top-[15px] left-[30px]"
                />
                {/* Sync control: the only sync cue on this page once the banner
                    is hidden with "Don't show again" (SUP-924). */}
                <div className="absolute top-[10px] right-[100px]">
                  {!editorVisible && (
                    <EditViewSyncButton navigate={navigate} />
                  )}
                </div>
              </div>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[87px] left-[150px] right-[1px] h-[58px] bg-white"
                    : "absolute top-[87px] left-[75px] right-[1px] h-[58px] bg-white"
                }
              >
                <p className="font-black font-mulish text-[20px] p-3 indent-4">
                  {cameraInfo.camera_name}
                </p>
              </div>
              <div className="absolute top-[97px] right-[100px]">
                {!editorVisible && (
                  <OrangeTextButton
                    onClick={() => {
                      setPageLoading(true);
                      setEditsMade(false);
                      handlePostMetadataTagZones(navigate);
                    }}
                    text="Submit Changes"
                    disabled={!editsMade}
                  />
                )}
              </div>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[145px] left-[150px] right-[1px] h-full bg-white"
                    : "absolute top-[145px] left-[75px] right-[1px] h-full bg-white"
                }
              >
                {!editorVisible && allCamerasData.length > 1 && (
                  <div className="pt-[200px] w-[40px]">
                    <Tooltip
                      title={`Previous Camera: ${
                        cameraIndex === 0
                          ? allCamerasData[allCamerasData.length - 1]
                              .camera_name
                          : allCamerasData[cameraIndex - 1].camera_name
                      }`}
                      placement="top"
                      sx={{ fontSize: "12px", fontFamily: "mulish" }}
                    >
                      <div>
                        <OrangeTextButton
                          onClick={() => {
                            const targetCameraId =
                              cameraIndex === 0
                                ? allCamerasData[allCamerasData.length - 1].id
                                : allCamerasData[cameraIndex - 1].id;

                            navigate(
                              `/sites/${siteId}/editcamera/${targetCameraId}/editmetadatatagzones`
                            );

                            // Reset state and reload data for the new camera
                            setPageLoading(true);
                            setEditorVisible(false);
                            setEditsMade(false);
                            setImageURLmdtz(""); // Clear image URL immediately
                            setSelectedMetadataTagZone({
                              camera: targetCameraId,
                              name: "",
                              description: "",
                              line_color: "",
                              coordinates: [],
                              metric_labels: [],
                            });

                            // Reload camera data
                            getAllCameras(
                              siteId,
                              targetCameraId,
                              setAllCamerasData,
                              setCameraIndex
                            );

                            // Reload page info for the new camera
                            setTimeout(() => {
                              getAllEditMetaDataTagZonesPageInfo(navigate);
                            }, 100);
                          }}
                          text={
                            <ArrowBackIosIcon
                              fontSize="large"
                              id="backButton"
                            />
                          }
                          disabled={allCamerasData.length < 2}
                        />
                      </div>
                    </Tooltip>
                  </div>
                )}
                {!editorVisible && allCamerasData.length > 1 && (
                  <div className="absolute top-[200px] left-[1300px]">
                    <Tooltip
                      title={`Next Camera: ${
                        cameraIndex + 1 === allCamerasData.length
                          ? allCamerasData[0].camera_name
                          : allCamerasData[cameraIndex + 1].camera_name
                      }`}
                      placement="top"
                      sx={{ fontSize: "12px", fontFamily: "mulish" }}
                    >
                      <div>
                        <OrangeTextButton
                          onClick={() => {
                            const targetCameraId =
                              cameraIndex + 1 === allCamerasData.length
                                ? allCamerasData[0].id
                                : allCamerasData[cameraIndex + 1].id;

                            navigate(
                              `/sites/${siteId}/editcamera/${targetCameraId}/editmetadatatagzones`
                            );

                            // Reset state and reload data for the new camera
                            setPageLoading(true);
                            setEditorVisible(false);
                            setEditsMade(false);
                            setImageURLmdtz(""); // Clear image URL immediately
                            setSelectedMetadataTagZone({
                              camera: targetCameraId,
                              name: "",
                              description: "",
                              line_color: "",
                              coordinates: [],
                              metric_labels: [],
                            });

                            // Reload camera data
                            getAllCameras(
                              siteId,
                              targetCameraId,
                              setAllCamerasData,
                              setCameraIndex
                            );

                            // Reload page info for the new camera
                            setTimeout(() => {
                              getAllEditMetaDataTagZonesPageInfo(navigate);
                            }, 100);
                          }}
                          text={
                            <ArrowForwardIosIcon
                              fontSize="large"
                              id="backButton"
                            />
                          }
                          disabled={allCamerasData.length < 2}
                        />
                      </div>
                    </Tooltip>
                  </div>
                )}
                {!editorVisible && (
                  <div>
                    <div
                      className={
                        !navBarCollapsed
                          ? "absolute left-[745px] top-[75px]"
                          : "absolute left-[755px] top-[75px]"
                      }
                    >
                      {metadataTagZones.length > 0 && (
                        <div className="absolute left-[0px] top-[0px]">
                          <Paper sx={{ width: 550, height: 360 }}>
                            <TableContainer sx={{ maxHeight: 360 }}>
                              <Table
                                sx={{
                                  fontFamily: "Mulish",
                                  tableLayout: "auto",
                                  minWidth: 500,
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        fontWeight: "bold",
                                        width: "60px",
                                        padding: "8px",
                                      }}
                                    >
                                      Color
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: "bold",
                                        padding: "8px",
                                      }}
                                    >
                                      Name
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: "bold",
                                        padding: "8px",
                                      }}
                                    >
                                      Metrics
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: "bold",
                                        width: "80px",
                                        padding: "8px",
                                      }}
                                    ></TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: "bold",
                                        width: "80px",
                                        padding: "8px",
                                      }}
                                    ></TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {metadataTagZones.map(
                                    (object: any, index: number) => {
                                      return (
                                        <TableRow key={object.id}>
                                          <TableCell
                                            sx={{
                                              width: "60px",
                                              padding: "8px",
                                            }}
                                          >
                                            <div
                                              key={object.label}
                                              style={{
                                                height: 25,
                                                width: 25,
                                                background: `${object.line_color}`,
                                                borderRadius: 4,
                                                margin: "0 auto",
                                              }}
                                            ></div>
                                          </TableCell>
                                          <TableCell sx={{ padding: "8px" }}>
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  maxWidth: "150px",
                                                }}
                                              >
                                                {object.name}
                                              </span>
                                              {object.description && (
                                                <Tooltip
                                                  title={object.description}
                                                  placement="top"
                                                  sx={{
                                                    fontSize: "15px",
                                                    fontFamily: "mulish",
                                                  }}
                                                >
                                                  <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                                                </Tooltip>
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell sx={{ padding: "8px" }}>
                                            <div
                                              style={{
                                                maxWidth: "200px",
                                              }}
                                            >
                                              {object.metric_labels
                                                .map((metricId: number) => {
                                                  const metric =
                                                    metricLabels.find(
                                                      (m) => m.id === metricId
                                                    );
                                                  return metric
                                                    ? metric.display_name
                                                    : `Unknown (${metricId})`;
                                                })
                                                .join(", ")}
                                            </div>
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              width: "80px",
                                              padding: "8px",
                                            }}
                                          >
                                            <OrangeTextButton
                                              onClick={() => {
                                                setSelectedMetadataTagZone(
                                                  object
                                                );
                                                setSelectedMetadataTagZoneIndex(
                                                  index
                                                );
                                                handleIgnoreZoneClick(object);
                                              }}
                                              text="Edit"
                                              disabled={false}
                                            />
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              width: "80px",
                                              padding: "8px",
                                            }}
                                          >
                                            <Tooltip
                                              title="Delete"
                                              placement="top"
                                              sx={{
                                                fontSize: "15px",
                                                fontFamily: "mulish",
                                              }}
                                            >
                                              <OrangeTextButton
                                                onClick={() => {
                                                  setPageLoading(true);
                                                  handleDeleteMetadataTagZone(
                                                    object.id,
                                                    navigate
                                                  );
                                                }}
                                                text={
                                                  <DeleteIcon fontSize="small" />
                                                }
                                                disabled={false}
                                              />
                                            </Tooltip>
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        </div>
                      )}
                      {metadataTagZones.length === 0 && (
                        <div className="absolute left-[80px] top-[130px] w-[275px]">
                          <p className="font-mulish text-[16px] indent-5">
                            No Metadata Tag Zones added
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {
                  // !pageLoading &&
                  !editorVisible && (
                    <div className="absolute top-[53px] left-[70px]">
                      <img
                        src={imageURLmdtz}
                        style={{
                          width: `${dimensions.width}px`,
                          height: `${dimensions.height}px`,
                        }}
                        onLoad={handleImageLoad}
                        alt="TestCameraPhoto"
                      />
                      {!editorVisible &&
                        metadataTagZones.map((object: any) => {
                          return (
                            <div
                              className="absolute top-[0px]"
                              key={object.label}
                            >
                              {object.coordinates[0] &&
                                object.coordinates.map(
                                  (array: any, index: any) => {
                                    return (
                                      <svg
                                        className="absolute top-[0px]"
                                        key={index}
                                        style={{
                                          width: `${dimensions.width}px`,
                                          height: `${dimensions.height}px`,
                                        }}
                                      >
                                        {dimensions && (
                                          <polygon
                                            points={pointsCreator(
                                              object.coordinates[index],
                                              dimensions.height,
                                              dimensions.width
                                            )}
                                            stroke={object.line_color}
                                            strokeWidth="5"
                                            fill={object.line_color}
                                            fillOpacity="50%"
                                          />
                                        )}
                                      </svg>
                                    );
                                  }
                                )}
                            </div>
                          );
                        })}
                    </div>
                  )
                }

                {editorVisible && (
                  <div
                    className="player absolute top-[0px] left-[67px] w-[775px] h-[200px]"
                    role="button"
                    tabIndex={0}
                  >
                    {mdtzBuilder}
                  </div>
                )}

                {/* <div className="absolute top-[7px] left-[150px] right-[1px] h-[170px] w-[640px] bg-white"></div> */}
              </div>
              {!editorVisible && (
                // metadataTagZones.length > 0 &&
                <div
                  className={
                    !navBarCollapsed
                      ? "absolute top-[167px] left-[900px] w-[460px] font-mulish text-[18px] font-bold text-actuate-blue flex"
                      : "absolute top-[167px] left-[825px] w-[460px] font-mulish text-[18px] font-bold text-actuate-blue flex"
                  }
                >
                  <>Metadata Tag Zones</>
                </div>
              )}
              {!editorVisible && (
                // metadataTagZones.length > 0 &&
                <div
                  className={
                    !navBarCollapsed
                      ? "absolute top-[164px] left-[1190px] w-[210px]"
                      : "absolute top-[164px] left-[1115px] w-[210px]"
                  }
                >
                  <OrangeTextButton
                    onClick={() => {
                      // Find the next available color that's not already used
                      const usedColors = metadataTagZones.map(
                        (zone) => zone.line_color
                      );
                      let nextColorIndex = 0;

                      // Find the first color that's not already used
                      for (
                        let i = 0;
                        i < metadataTagZonesColorArray.length;
                        i++
                      ) {
                        if (
                          !usedColors.includes(metadataTagZonesColorArray[i])
                        ) {
                          nextColorIndex = i;
                          break;
                        }
                      }

                      // If all colors are used, cycle through them starting from the current index
                      if (
                        usedColors.length >= metadataTagZonesColorArray.length
                      ) {
                        nextColorIndex = shapeColorIndex;
                        setShapeColorIndex(
                          (shapeColorIndex + 1) %
                            metadataTagZonesColorArray.length
                        );
                      } else {
                        setShapeColorIndex(nextColorIndex);
                      }

                      const selectedColor =
                        metadataTagZonesColorArray[nextColorIndex];
                      setShapeColor(selectedColor);

                      setNewMetadataTagZone({
                        camera: Number(
                          getNumbersAfterEditCamera(location.href)
                        ),
                        name: "",
                        description: "",
                        line_color: selectedColor,
                        coordinates: [],
                        metric_labels: [],
                      });
                      // Clear shapes for new metadata tag zone
                      setShapesArray([]);
                      setMtzPolygonPoints([]);
                      setAddMetaDataIgnoreZoneDialogOpen(true);
                    }}
                    text="+ Add Metadata Tag Zone"
                    disabled={false}
                  />
                </div>
              )}
              {editorVisible && (
                <div
                  className={
                    !navBarCollapsed
                      ? largerMode
                        ? "absolute top-[212px] left-[1280px] font-mulish text-[20px] text-actuate-blue min-w-[470px] pr-[40px]"
                        : "absolute top-[212px] left-[980px] font-mulish text-[20px] text-actuate-blue min-w-[470px] pr-[40px]"
                      : largerMode
                      ? "absolute top-[212px] left-[1200px] font-mulish text-[20px] text-actuate-blue min-w-[500px] pr-[40px]"
                      : "absolute top-[212px] left-[900px] font-mulish text-[20px] text-actuate-blue min-w-[500px] pr-[40px]"
                  }
                >
                  <div className="pt-[10px]">
                    <TextField
                      label="Name"
                      variant="standard"
                      value={selectedMetadataTagZone.name}
                      onChange={(event) => {
                        if (
                          selectedMetadataTagZoneIndex !== null &&
                          !editedTagZoneIndexes.includes(
                            selectedMetadataTagZoneIndex
                          )
                        ) {
                          setEditedTagZoneIndexes([
                            ...editedTagZoneIndexes,
                            selectedMetadataTagZoneIndex,
                          ]);
                        }
                        setEditsMade(true);
                        setSelectedMetadataTagZone({
                          ...selectedMetadataTagZone,
                          name: event.target.value,
                        });
                      }}
                      onKeyDown={(event) => {
                        // Prevent backspace from bubbling up to PolygonDrawer
                        event.stopPropagation();
                      }}
                      sx={{ width: 395 }}
                      helperText=""
                      type="string"
                    />
                    <div className="pt-[30px]">
                      <Autocomplete
                        multiple
                        disablePortal
                        options={metricLabels}
                        value={metricLabels.filter((metric) =>
                          selectedMetadataTagZone.metric_labels.includes(
                            metric.id
                          )
                        )}
                        onChange={(event, value) => {
                          if (
                            selectedMetadataTagZoneIndex !== null &&
                            !editedTagZoneIndexes.includes(
                              selectedMetadataTagZoneIndex
                            )
                          ) {
                            setEditedTagZoneIndexes([
                              ...editedTagZoneIndexes,
                              selectedMetadataTagZoneIndex,
                            ]);
                          }
                          setEditsMade(true);
                          setSelectedMetadataTagZone({
                            ...selectedMetadataTagZone,
                            metric_labels: value.map((metric) => metric.id), // Extract IDs
                          });
                        }}
                        onKeyDown={(event) => {
                          // Prevent backspace from bubbling up to PolygonDrawer
                          event.stopPropagation();
                        }}
                        getOptionLabel={(option) => option.display_name}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        sx={{ width: 395 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Metrics"
                            onKeyDown={(event) => {
                              // Prevent backspace from bubbling up to PolygonDrawer
                              event.stopPropagation();
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="pt-[40px]">
                      <TextField
                        label="Description"
                        multiline
                        rows={4}
                        value={selectedMetadataTagZone.description}
                        onChange={(event) => {
                          if (
                            selectedMetadataTagZoneIndex !== null &&
                            !editedTagZoneIndexes.includes(
                              selectedMetadataTagZoneIndex
                            )
                          ) {
                            setEditedTagZoneIndexes([
                              ...editedTagZoneIndexes,
                              selectedMetadataTagZoneIndex,
                            ]);
                          }
                          setEditsMade(true);
                          setSelectedMetadataTagZone({
                            ...selectedMetadataTagZone,
                            description: event.target.value,
                          });
                        }}
                        onKeyDown={(event) => {
                          // Prevent backspace from bubbling up to PolygonDrawer
                          event.stopPropagation();
                        }}
                        sx={{ width: 395 }}
                        helperText="Optional"
                        type="string"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )
        }
      </div>
      <div className="justify-start">
        <NavBar
          navBarCollapsed={navBarCollapsed}
          setNavBarCollapsed={setNavBarCollapsed}
          props={{}}
        />
      </div>
    </div>
  );
};
